jQuery(document).ready(function () {
  $('.header-top-language').off('click');

  var $document = jQuery(document);
  var $navigation = jQuery('#main-navigation');

  $document.on('click', '.header-top-language', function (e) {
    var $this = jQuery(this);

    if (!$navigation.hasClass('language-toggle-open')) {
      $navigation.addClass('navigation-white');
      $navigation.addClass('language-toggle-open');
    } else {
      ($navigation.data('navigation-style') != 'white'
          && !$('.header-top-price-dropdown').hasClass('open')
          && !$('#megamenu').hasClass('active') ) && $navigation.removeClass('navigation-white');
      $navigation.removeClass('language-toggle-open');
    }
  });
});
